import {Col, Row} from "react-bootstrap";
import React from "react";

export const BottomModal =
    <Row className="fixed-bottom" style={{marginLeft: '0px', marginRight: '0px'}}>
        <Col md={12} style={{ borderBottomLeftRadius:'5px', borderBottomRightRadius: '5px', height: '18px', background: '#d8d8d8', color: 'white' }}>
        </Col>
    </Row>